module.exports = __webpack_public_path__ + "img/p29271.430dccfa.jpg";